<button type="button" class="btn btn-sort-order" (click)="changeSort()">
    <i class="fa fa-sort fa-lg" aria-hidden="true" *ngIf="sortStatus === null" ngbTooltip="Click to sort"></i>
    <i class="fa fa-sort-asc fa-lg" aria-hidden="true" *ngIf="sortStatus === 'asc'" ngbTooltip="Sorted: Ascending"></i>
    <i class="fa fa-sort-desc fa-lg" aria-hidden="true" *ngIf="sortStatus === 'desc'" ngbTooltip="Sorted: Descending"></i>
<!--    <span title="Sort priority" ngbTooltip="Sort Priority"> {{ sortOrder }}</span>-->
</button>
<button type="button" class="btn btn-sort-order" (click)="clearSort()" *ngIf="sortStatus !== null">
    <i class="fa fa-times fa-lg" aria-hidden="true" ngbTooltip="Stop sorting by this column"></i>
</button>
